module.exports = __webpack_public_path__ + "static/media/5C.4b4b8394.svg";